export default __webpack_public_path__ + "static/media/vmx-bubble.87daddc2.png";